import { render, staticRenderFns } from "./openCorporateComponent.vue?vue&type=template&id=52851714"
import script from "./openCorporateComponent.vue?vue&type=script&lang=js"
export * from "./openCorporateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports